import { type FundListItem } from '@d3/contract';

import type { Fund, FundOption } from '../model/fund';

/**
 * 경량 응답(지표 없음) → Select · 드롭다운용 가벼운 모양. id · 이름만.
 * 계약 FundListItem 은 id 기반(레거시 idx) — 뷰모델의 idx 로 흡수한다.
 */
export function toFundOption(item: FundListItem): FundOption {
  return { idx: item.id, name: item.name };
}

/**
 * 지표 포함 응답 → 펀드 목록 뷰모델(메인 · 펀드 목록). 계약이 `indicators` 로 묶은 지표를
 * 화면이 쓰는 평면 필드로 흡수한다. 결성/만기 · 투자기간은 계약이 시작/끝으로 나눴다 → 뷰모델의 튜플로.
 * 경량 조회(withIndicators=false)로 받으면 indicators 가 null — 그때는 toFundOption 을 쓴다.
 */
export function toFund(item: FundListItem): Fund {
  const i = item.indicators;
  return {
    idx: item.id,
    name: item.name,
    businessNumber: null,
    fundDuration: [item.fundStart ?? '', item.fundEnd ?? ''],
    investDuration: [item.investStart ?? '', item.investEnd ?? ''],
    fundingRound: [item.fundingRoundMin ?? '', item.fundingRoundMax ?? ''],
    commentInvestmentTarget: item.investmentTargetComment ?? '',
    volumeCashCapitalContribution: i?.contribution ?? 0,
    volumeCashCapitalPayment: i?.payment ?? 0,
    volumeCashInvested: i?.invested ?? 0,
    volumeCashUninvested: i?.uninvested ?? 0,
    volumeCashInvestable: i ? i.invested + i.uninvested : 0,
    volumeCashEquivalent: 0,
    volumeCashTotalExit: i?.totalExit ?? 0,
    volumeCashTotalValuation: i?.totalValuation ?? 0,
    NumberOfExitComplete: i?.completeExitCount ?? 0,
    NumberOfExitPartial: i?.partialExitCount ?? 0,
    irr1: i?.grossIrr ?? 0,
    irr2: i?.netIrr ?? 0,
    multiple: i?.multiple ?? 0,
    multipleExit: i?.exitMultiple ?? 0,
    dpi: i?.dpi ?? null,
    rvpi: i?.rvpi ?? null,
    tvpi: i?.tvpi ?? null,
    burnrate: i?.burnRate ?? 0,
  };
}
